import { AlgChannelService } from "./channel.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiVisa } from '../../../shared/api-visa.model';
import { Core2Config } from "../../../shared";

@Injectable({ providedIn: "root" })
export class FacebookFeedCommentService extends AlgChannelService {

  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE
    this.httpClient = httpClient;
    this.endpointPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE
  }

  public sendNewComment(data: any, apiVisa: ApiVisa) {
    const url = apiVisa.api_domain_url +  this.endpointPath + "facebook/feed/send-comment"
    return this.httpClient.post(
      url,
      data,
      this.getHeader(apiVisa)
    )
  }

  public replyComment(data: any, apiVisa: ApiVisa) {
    const url = apiVisa.api_domain_url +  this.endpointPath + "facebook/feed/send-reply"
    return this.httpClient.post(
      url,
      data,
      this.getHeader(apiVisa)
    )
  }

  public deleteComment(data: any, apiVisa: ApiVisa) {
    const url = apiVisa.api_domain_url +  this.endpointPath + 'facebook/feed/delete'
    return this.httpClient.post(
      url,
      data,
      this.getHeader(apiVisa)

    )

  }

  public editComment(data: any, apiVisa: ApiVisa) {
    const url = apiVisa.api_domain_url +  this.endpointPath + 'facebook/feed/update-comment';
    return this.httpClient.post(
      url,
      data,
      this.getHeader(apiVisa)
    )
  }


  getHeader(apiVisa) {
    let headers = new HttpHeaders({
        'tenant_code': apiVisa.tenantCode
    })
    return { headers: headers };
}

}